import Footer from '@buddieshr/components/footer';
import Header from '@buddieshr/components/header';
import MetaHeader from '@buddieshr/components/metaHeader';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { GSHero, GSInstall } from '@buddieshr/components/getStarted/sections';

const GetStarted = ({ refSource }) => {
  const { t } = useTranslation();
  const router = useRouter();

  return (
    <>
      <MetaHeader
        title={t('metaTitleGetStarted')}
        description={t('descriptionContentGetStarted')}
        currentURL={`https://buddieshr.com/${
          router.locale === 'en' ? '' : router.locale
        }/get-started`}
        locale={router.locale}
        pageSlug="get-started"
      />
      <Header overlay />
      <main className="bh bh-overlay-header">
        <GSHero refSource={refSource} />
        <GSInstall />
      </main>
      <Footer refSource={refSource} />
    </>
  );
};

export default GetStarted;
